// extracted by mini-css-extract-plugin
export var numpadContainer = "_ss-1";
export var phoneButton = "_ss-0";